import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M120,180 L120,1740 C120,1773 146.88,1800 180,1800 L1200,1800 L1200,120 L180,120 C146.88,120 120,147 120,180 Z M1740,120 L1320,120 L1320,600 L1800,600 L1800,180 C1800,147 1773.12,120 1740,120 Z M1800,720 L1320,720 L1320,1200 L1800,1200 L1800,720 Z M1740,1800 C1773.12,1800 1800,1773 1800,1740 L1800,1320 L1320,1320 L1320,1800 L1740,1800 Z M180,1920 C80.76,1920 -2.27373675e-13,1839.24 -2.27373675e-13,1740 L-2.27373675e-13,180 C-2.27373675e-13,80.76 80.76,-2.27373675e-13 180,-2.27373675e-13 L1740,-2.27373675e-13 C1839.24,-2.27373675e-13 1920,80.76 1920,180 L1920,1740 C1920,1839.24 1839.24,1920 1740,1920 L180,1920 Z M776.484,1410 L536.484,1410 L536.484,1080 L206.484,1080 L206.484,840 L536.484,840 L536.484,510 L776.484,510 L776.484,840 L1106.484,840 L1106.484,1080 L776.484,1080 L776.484,1410 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTableInsertColumnBeforeLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTableInsertColumnBeforeLine, _Component);

  var _super = _createSuper(IconTableInsertColumnBeforeLine);

  function IconTableInsertColumnBeforeLine() {
    _classCallCheck(this, IconTableInsertColumnBeforeLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTableInsertColumnBeforeLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTableInsertColumnBefore",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTableInsertColumnBeforeLine.displayName = "IconTableInsertColumnBeforeLine";
  return IconTableInsertColumnBeforeLine;
}(Component);

IconTableInsertColumnBeforeLine.glyphName = 'table-insert-column-before';
IconTableInsertColumnBeforeLine.variant = 'Line';
IconTableInsertColumnBeforeLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTableInsertColumnBeforeLine;
export { IconTableInsertColumnBeforeLine };